<template>
 <div>
  <template v-if="!show">
       <el-breadcrumb class="app-breadcrumb" separator="/">
    <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
      <span v-if="item.redirect === 'noRedirect' || index == levelList.length - 1" class="no-redirect">{{ item.meta.title }}</span>
      <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
    </el-breadcrumb-item>
  </el-breadcrumb>
  </template>

 </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null,
      show:false,
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    },
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    isHome(route) {
      return route.path === '/welcome'
    },
    getBreadcrumb() {
      let matched = this.$route.matched
   
      this.$route.path == '/welcome/welcome'?this.show = true:this.show = false
  
      //如果不是首页
      if (!this.isHome(matched[0])) {
        matched = [].concat(matched)
        if (matched[0].path == '/index') {
          matched = [{ path: '/index/index', meta: { title: '首页' } }]
        }
      } else {
        matched = [{ path: '/welcome/welcome', meta: { title: '首页' } }]
      }
      this.levelList = matched
    },
    pathCompile(path) {
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    },
  },
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>

